import { render, staticRenderFns } from "./mizan.vue?vue&type=template&id=49f18d00&scoped=true&"
import script from "./mizan.vue?vue&type=script&lang=js&"
export * from "./mizan.vue?vue&type=script&lang=js&"
import style0 from "./mizan.vue?vue&type=style&index=0&id=49f18d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f18d00",
  null
  
)

export default component.exports